import { faCog } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { WidgetBox } from "shared/containers/WidgetBox";
import { DARK_BLUE } from "theme/colors";

export const AppSettings: React.FC = () => {
  const { t } = useTranslation();

  return (
    <WidgetBox
      data-testid="app-settings-container"
      icon={<FontAwesomeIcon icon={faCog} />}
      title={t("settings.app_settings.heading")}
      color="blue"
    >
      <Stack>
        <Stack direction="row" spacing="10px" py={2} alignItems="center">
          <Typography variant="subtitle1" color={DARK_BLUE[60]}>
            {t("settings.app_settings.app_version")}
          </Typography>
          <Typography variant="subtitle1" color="text.primary">
            {process.env.REACT_APP_VERSION ?? "-"}
          </Typography>
        </Stack>
      </Stack>
    </WidgetBox>
  );
};
